module.exports = __webpack_public_path__ + "img/success.5ce2c956.png";